import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { isFormatted, parseDatePickerValue } from '../../../utils/datepicker-value-parser';
import { DateRange } from '../../../models/date-range';
import { startOfDay, subDays } from 'date-fns';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  dateRangeComponentValidator,
  dateRangeRequired,
  valuesAreDates
} from '../../../utils/dateRangeValidator';

@Component({
  selector: 'lib-on-demand-reports',
  templateUrl: './on-demand-reports.component.html',
  styleUrls: ['./on-demand-reports.component.css'],
  standalone: false
})
export class OnDemandReportsComponent implements OnInit {
  @Input() public clientCode: string;
  dateRange = '0';
  @Input()
  reportView = 'payroll-audit';
  dateError = null;
  show = false;

  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      dateRange: this.fb.control({ start: null, end: null }, [
        dateRangeRequired,
        dateRangeComponentValidator,
        valuesAreDates
      ])
    });
  }

  public checkDateRanges() {
    // when custom date ranges is selected
    // clear the start/end dates to avoid and UX confusion.
    if (this.dateRange == 'custom') {
      this.form.get('dateRange').setValue({ start: null, end: null });
    }
    this.dateError = null;
  }

  public generate() {
    this.show = false;
    this.dateError = null;
    if (this.dateRange !== 'custom') {
      const start = startOfDay(subDays(new Date(), parseInt(this.dateRange)));
      const end = startOfDay(new Date());
      this.form.get('dateRange').setValue({ start, end });
    } else {
      /*
      // validate that the user entered a valid date
      this.dates.start = !isFormatted(this.dates.start)
        ? parseDatePickerValue(this.dates.start)
        : this.dates.start;
      this.dates.end = !isFormatted(this.dates.end) ? parseDatePickerValue(this.dates.end) : this.dates.end;

      // if both start and end date are blank,
      // force the user to pick at least one
      // if the start date and end date are farther than 30 days, throw error
      if (!this.dates.start && !this.dates.end) {
        this.dateError = 'Start Date and End Date are required.';
        return;
      }

       */
    }

    setTimeout(() => {
      this.show = true;
    }, 250);
  }

  public onDateChange() {
    /*
    if (!this.startDate || !this.endDate) {
      this.dateError = 'Start Date and End Date are required.';
    } else {
      // bug 15042
      const start = new Date(parseDatePickerValue(this.startDate));
      const end = new Date(parseDatePickerValue(this.endDate));

      if (start > end) {
        this.dateError = 'Start Date must come before End Date';
        return;
      }

      const oneDay = 1000 * 60 * 60 * 24;
      const diffInTime = end.getTime() - start.getTime();

      const diffInDays = Math.round(diffInTime / oneDay);

      this.dateError =
        diffInDays > 30 ? 'Start Date and End Date cannot be more than 30 days apart.' : null;
    }

  */
  }
}
